import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const Layout: React.FC = () => {
  return (
    <>
      <main>
        <Outlet />
      </main>
      <footer className="footer">
        <Link to="/support" className="footer-link">support</Link>
        <Link to="/privacy" className="footer-link">privacy</Link>
        <Link to="/opensource" className="footer-link">open source</Link>
      </footer>
    </>
  );
};

export default Layout;
